import React from 'react';

type Props = {
  className: string;
};

const ImagePlaceholder = (props: Props) => (
  <svg width="120" height="80" viewBox="0 0 120 80" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <rect width="120" height="80" fill="#F5F5F5" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M75 51.6667V28.3333C75 26.5 73.5 25 71.6667 25H48.3333C46.5 25 45 26.5 45 28.3333V51.6667C45 53.5 46.5 55 48.3333 55H71.6667C73.5 55 75 53.5 75 51.6667ZM54.1667 42.5L58.3333 47.5167L64.1667 40L71.6667 50H48.3333L54.1667 42.5Z"
      fill="#E0E0E0"
    />
  </svg>
);

export default ImagePlaceholder;
